import { motion } from 'framer-motion'
import CloseBubbleIcon from '../../../../assets/svgs/CloseBubble'
import EditIcon from '../../../../assets/svgs/EditIcon'
import PlusCircleIcon from '../../../../assets/svgs/PlusCircle'
import style from './MainProfile.module.css'

/* ---- Company initial avatar (no external API — works offline & avoids tracking blocks) ---- */
const logoColors = [
  '#432c5b', '#61487c', '#7c5e9a', '#3b5998', '#1d6fa4',
  '#2e7d32', '#c62828', '#e65100', '#4a148c', '#00695c',
]

const CompanyLogo = ({ companyName }) => {
  const words = companyName?.split(' ').filter(Boolean) || []
  const initials = words.length >= 2
    ? (words[0][0] + words[1][0]).toUpperCase()
    : (words[0]?.[0] || '?').toUpperCase()

  const colorIdx = (companyName?.charCodeAt(0) || 0) % logoColors.length

  return (
    <div
      className={style.cardImage}
      style={{
        background: logoColors[colorIdx],
        color: '#fff',
        fontSize: initials.length > 1 ? 15 : 20,
        fontWeight: 700,
        fontFamily: 'Poppins, sans-serif',
        letterSpacing: '0.5px',
      }}
    >
      {initials}
    </div>
  )
}

/* ---- Employment type colour map ---- */
const typeColors = {
  'Full-time': '#2e7d32',
  'Part-time': '#1565c0',
  Freelance: '#e65100',
  Contract: '#6a1b9a',
  Internship: '#00695c',
  Volunteer: '#ad1457',
}

const fadeUp = {
  hidden: { opacity: 0, y: 14 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.38, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] },
  }),
}

const Experience = ({ toggleModal, userProfile, owner, removeComponent, editMode }) => {
  if (!userProfile.experience?.length) return null

  return (
    <div className={style.experienceWrapper}>
      <div className={style.experienceActions}>
        <p className={style.title}>Experience</p>
        {owner && editMode && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div
              className={style.plus}
              onClick={() => toggleModal('experience', userProfile, 'create')}
              title="Add experience"
            >
              <PlusCircleIcon color="white" />
            </div>
            <div
              onClick={() => removeComponent('2')}
              style={{ cursor: 'pointer', opacity: 0.65 }}
              title="Remove section"
            >
              <CloseBubbleIcon color="#393D63" height={20} width={20} />
            </div>
          </div>
        )}
      </div>

      <motion.div
        className={style.cardsContainer}
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {userProfile.experience.map((item, index) => (
          <motion.div
            className={style.singleCard}
            key={index}
            variants={fadeUp}
            custom={index}
          >
            {/* Company logo */}
            <CompanyLogo companyName={item.company_name} />

            {/* Info */}
            <div className={style.cardInfo}>
              <p className={style.cardTitle}>{item.title}</p>
              <p className={style.cardCompany}>{item.company_name}</p>

              {/* Employment type badge */}
              {item.employment_type && (
                <span
                  className={style.cardBadge}
                  style={{
                    background: `${typeColors[item.employment_type] || '#432c5b'}18`,
                    color: typeColors[item.employment_type] || '#432c5b',
                    alignSelf: 'flex-start',
                  }}
                >
                  {item.employment_type}
                </span>
              )}

              <p className={style.cardSubtext}>
                {item.start_date}
                {item.end_date ? ` — ${item.end_date}` : ''}
              </p>
              {item.location && (
                <p className={style.cardSubtext}>
                  📍 {item.location}
                  {item.location_type ? ` · ${item.location_type}` : ''}
                </p>
              )}
            </div>

            {/* Edit icon (hover) */}
            {owner && editMode && (
              <div
                onClick={() => toggleModal('experience', item)}
                className={style.edit}
                title="Edit"
              >
                <EditIcon />
              </div>
            )}
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}

export default Experience
